// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-select-migration-to-workbook-dialog-body {
  border-radius: 8px;
  box-shadow: 0px 0px 0px 1px var(--g-color-line-generic);
  padding: 20px 20px 28px;
  cursor: pointer;
  color: var(--g-color-text-primary);
}
.dl-select-migration-to-workbook-dialog-body_active {
  box-shadow: 0px 0px 0px 2px var(--g-color-base-brand);
}
.dl-select-migration-to-workbook-dialog-body__header {
  display: flex;
}
.dl-select-migration-to-workbook-dialog-body__title {
  font-size: 28px;
  font-weight: 500;
  line-height: 32px;
}
.dl-select-migration-to-workbook-dialog-body__label {
  margin-left: 8px;
}
.dl-select-migration-to-workbook-dialog-body__icon {
  margin-left: auto;
}
.dl-select-migration-to-workbook-dialog-body__description {
  padding: 8px 0;
  margin: 20px 0;
  border-bottom: 1px solid var(--g-color-line-generic);
  border-top: 1px solid var(--g-color-line-generic);
  color: var(--g-color-text-complementary);
}
.dl-select-migration-to-workbook-dialog-body__content {
  margin-top: 16px;
  min-height: 151px;
}
.dl-select-migration-to-workbook-dialog-body__content-item {
  margin: 20px 0;
  display: flex;
}
.dl-select-migration-to-workbook-dialog-body__content-item-text {
  margin-left: 12px;
}
.dl-select-migration-to-workbook-dialog-body__content-item-help {
  margin-left: auto;
}
.dl-select-migration-to-workbook-dialog-body__content-tooltip {
  max-width: 170px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/SelectMigrationToWorkbookDialog/Body/Body.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,uDAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;AACJ;AACI;EACI,qDAAA;AACR;AAEI;EACI,aAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,iBAAA;AAHR;AAMI;EACI,cAAA;EACA,cAAA;EACA,oDAAA;EACA,iDAAA;EACA,wCAAA;AAJR;AAOI;EACI,gBAAA;EAEA,iBAAA;AANR;AASI;EACI,cAAA;EACA,aAAA;AAPR;AAUI;EACI,iBAAA;AARR;AAWI;EACI,iBAAA;AATR;AAYI;EACI,gBAAA;AAVR","sourcesContent":[".dl-select-migration-to-workbook-dialog-body {\n  border-radius: 8px;\n  box-shadow: 0px 0px 0px 1px var(--g-color-line-generic);\n  padding: 20px 20px 28px;\n  cursor: pointer;\n  color: var(--g-color-text-primary);\n}\n.dl-select-migration-to-workbook-dialog-body_active {\n  box-shadow: 0px 0px 0px 2px var(--g-color-base-brand);\n}\n.dl-select-migration-to-workbook-dialog-body__header {\n  display: flex;\n}\n.dl-select-migration-to-workbook-dialog-body__title {\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 32px;\n}\n.dl-select-migration-to-workbook-dialog-body__label {\n  margin-left: 8px;\n}\n.dl-select-migration-to-workbook-dialog-body__icon {\n  margin-left: auto;\n}\n.dl-select-migration-to-workbook-dialog-body__description {\n  padding: 8px 0;\n  margin: 20px 0;\n  border-bottom: 1px solid var(--g-color-line-generic);\n  border-top: 1px solid var(--g-color-line-generic);\n  color: var(--g-color-text-complementary);\n}\n.dl-select-migration-to-workbook-dialog-body__content {\n  margin-top: 16px;\n  min-height: 151px;\n}\n.dl-select-migration-to-workbook-dialog-body__content-item {\n  margin: 20px 0;\n  display: flex;\n}\n.dl-select-migration-to-workbook-dialog-body__content-item-text {\n  margin-left: 12px;\n}\n.dl-select-migration-to-workbook-dialog-body__content-item-help {\n  margin-left: auto;\n}\n.dl-select-migration-to-workbook-dialog-body__content-tooltip {\n  max-width: 170px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
